module.exports = __webpack_public_path__ + "static/img/happyBirthday.c985ca68.png";